import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const tapApi = createApi({
  reducerPath: 'tapApi',
  baseQuery: fetchBaseQuery({ baseUrl: `${process.env.REACT_APP_API_URL}/magneto/clevertap/send-event-from-web` }),
  endpoints: (builder) => ({
    tapClick: builder.mutation({
      query: ({event_name, event_property}) => {
        const body = {
          event_name,
          event_property
        };
        return {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            source: 'web',
            partner_code: window.localStorage.getItem('code'),
            jwt_token: window.localStorage.getItem('jwt')
          },
         body,
        };
      },
    }),
  })
})

export const { useTapClickMutation } = tapApi;
